import React from 'react';

const PageSpinner = () => {
  return (
    <div>
      <p>Loading...</p>
    </div>
  );
};

export default PageSpinner;
